module.exports = __webpack_public_path__ + "static/media/close.0ad2e4f7.svg";